import { render } from "./InspecaoValoresArquivos.vue?vue&type=template&id=5a7be7f9&scoped=true&ts=true"
import script from "./InspecaoValoresArquivos.vue?vue&type=script&lang=ts"
export * from "./InspecaoValoresArquivos.vue?vue&type=script&lang=ts"

import "./InspecaoValoresArquivos.vue?vue&type=style&index=0&id=5a7be7f9&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7be7f9"]])

export default __exports__